import { createSlice } from '@reduxjs/toolkit'

export const actasSlice = createSlice({
  name: 'actas',
  initialState: {
    customerCode: null,
    CustomerDescription: null,
    jdaLocationCode: null,
    jdaLocationDescription: null,
    shopCode: null,
    shopDescription: null
  },
  reducers: {
    setActAs: (state, action) => {
      state.customerCode = action.payload.customerCode;
      state.customerDescription = action.payload.customerDescription;
      state.jdaLocationCode = action.payload.jdaLocationCode;
      state.jdaLocationDescription = action.payload.jdaLocationDescription;
      state.shopCode = action.payload.shopCode;
      state.shopDescription = action.payload.shopDescription;
    },
    resetActAs: (state, action) => {
      state.customerCode = null;
      state.CustomerDescription = null;
      state.jdaLocationCode = null;
      state.jdaLocationDescription = null;
      state.shopCode = null;
      state.shopDescription = null;
    }
  },
})

export const { setActAs, resetActAs } = actasSlice.actions

export default actasSlice.reducer